import React from "react";
import { Card, CardHeader, CardContent } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

export function ProductSkeletonCard() {
	return (
		<Card style={{ padding: "10px", borderRadius: 8 }}>
			<CardHeader
				title={<Skeleton variant="text" width="80%" />}
				style={{ paddingBottom: 0 }}
			/>
			<CardContent>
				<div style={{ display: "flex", justifyContent: "center" }}>
					<Skeleton variant="rect" width={150} height={200} />
				</div>
				<div style={{ marginTop: 12 }}>
					<Skeleton variant="text" width="60%" />
					<Skeleton variant="text" width="40%" />
				</div>
			</CardContent>
		</Card>
	);
}
